import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "acSwitch_control" }
const _hoisted_2 = { class: "acSwitch_slot" }
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "acSwitch_input" }
const _hoisted_5 = ["aria-checked", "id", "aria-disabled", "value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "acSwitch_track" }, null, -1)
const _hoisted_7 = {
  class: "acSwitch_thumb",
  "aria-selected": "true"
}
const _hoisted_8 = {
  key: 0,
  role: "progressbar",
  "aria-valuemin": "0",
  "aria-valuemax": "100",
  class: "acSwitch_progress"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "22.857142857142858 22.857142857142858 45.714285714285715 45.714285714285715"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "transparent",
    cx: "45.714285714285715",
    cy: "45.714285714285715",
    r: "20",
    "stroke-width": "5.714285714285714",
    "stroke-dasharray": "125.664",
    "stroke-dashoffset": "125.66370614359172px",
    class: "acSwitch_progress_overlay"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["acSwitch", {
      '-is-dirty': _ctx.modelValue,
      '-is-disabled': _ctx.disabled
    }]),
    "aria-selected": "false",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              for: _ctx.switchId,
              class: "acSwitch_label"
            }, _toDisplayString(_ctx.label), 9, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("input", {
            "aria-checked": _ctx.modelValue,
            id: _ctx.switchId,
            role: "switch",
            type: "checkbox",
            "aria-disabled": _ctx.disabled,
            value: _ctx.modelValue
          }, null, 8, _hoisted_5),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "icon", {}, () => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 2))
}